export default __webpack_public_path__ + "static/media/PlayerWon.6d4499fe.png";